import React from 'react';
import {
  Button as RebassButton,
  ButtonProps as RebassButtonProps,
} from 'rebass';
import Icon, { IconType } from '../Icon/Icon';
import { isMobile, isTablet } from 'react-device-detect';

type buttonVariants =
  | 'primary'
  | 'secondary'
  | 'danger'
  | 'outline'
  | 'link'
  | 'success'; // keyOf from  button variants

export type ButtonProps = Omit<RebassButtonProps, 'css'> & {
  /**
   * Style of button
   */
  variant?: buttonVariants;
  /**
   * Icon to be included
   */
  icon?: IconType;
  /**
   * Used when as={Link}
   */
  to?: string;
};

const Button = (props: ButtonProps): JSX.Element => {
  const { icon, children, title, variant = 'primary' } = props;
  const renderChildren = !!children && (!icon || !isMobile || isTablet);

  if (variant !== 'link' && props.onClick && props.type !== 'submit') {
    const oldProps = props;
    props = {
      ...oldProps,
      onClick: (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        oldProps.onClick?.(e);
      },
    };
  }

  return (
    <RebassButton
      {...props}
      type={props.type ?? (variant === 'link' ? 'button' : undefined)}
      variant={variant}
      sx={{
        ...(variant === 'link' ? {} : { gap: 1 }),
        ...props.sx,
      }}
      pr={renderChildren ? undefined : [2, 2, 2]}
      pl={renderChildren ? undefined : [2, 2, 2]}
      title={
        title ||
        (!renderChildren && typeof children === 'string' ? children : undefined)
      }
    >
      {icon && (
        <Icon
          style={{
            marginLeft: renderChildren ? '-0.2em' : undefined,
          }}
          pointerEvents="none"
          icon={icon}
        />
      )}
      {renderChildren ? children : undefined}
    </RebassButton>
  );
};

export default Button;
